/* Mellor II PDP: sort the size grid, add size hint, selection line. */
(() => {
  if (window.__mpdpSizes) return;
  window.__mpdpSizes = true;
  // A size counts as chosen only once the shopper taps one (or arrives with ?variant= in the URL)
  let picked = /[?&]variant=/.test(location.search);
  const SIZE_RADIO = '.variant-picker__option--size .variant-picker-tabs__radio';
  const atcButtons = () => [...document.querySelectorAll('[data-block-type="buy-buttons"] button[type="submit"], product-sticky-bar button')]
    .filter((b) => b.dataset.mpdpOrig || /add to (cart|bag)|pre-?order/i.test(b.textContent));
  const setButtons = (needSize) => {
    atcButtons().forEach((b) => {
      if (needSize) {
        if (!b.dataset.mpdpOrig) b.dataset.mpdpOrig = b.innerHTML;
        if (!b.classList.contains('mpdp-needs-size')) { b.classList.add('mpdp-needs-size'); b.innerHTML = '<span>Select a size</span>'; }
      } else if (b.classList.contains('mpdp-needs-size')) {
        b.classList.remove('mpdp-needs-size');
        if (b.dataset.mpdpOrig) b.innerHTML = b.dataset.mpdpOrig;
        delete b.dataset.mpdpOrig;
      }
    });
  };
  const goToSizes = () => {
    const set = document.querySelector('.variant-picker__option--size');
    if (!set) return;
    set.scrollIntoView({ behavior: 'smooth', block: 'center' });
    set.classList.remove('mpdp-flash'); void set.offsetWidth; set.classList.add('mpdp-flash');
  };
  const blockIfNeeded = (e) => {
    if (picked || !document.querySelector('[data-mpdp-sizes][data-require-size]')) return;
    // Products without a size option (for example care products) can be added directly.
    if (!document.querySelector('.shopify-section--main-product .variant-picker__option--size .variant-picker-tabs__radio')) return;
    const btn = e.target.closest && e.target.closest('button');
    const isAtc = btn && (btn.classList.contains('mpdp-needs-size'));
    const isFormSubmit = e.type === 'submit' && e.target.closest && e.target.closest('product-form, form[action*="/cart/add"]');
    if (isAtc || isFormSubmit) { e.preventDefault(); e.stopImmediatePropagation(); goToSizes(); }
  };
  document.addEventListener('click', blockIfNeeded, true);
  // Size guide -> our size guide sheet, with a UK / EU / US table built from this product's sizes
  const buildSizeTable = (d) => {
    const box = d.querySelector('[data-mpdp-sg-table]');
    const tabs = document.querySelector('.variant-picker__option--size variant-picker-tabs');
    if (!box || !tabs) return;
    const rows = [...tabs.querySelectorAll('.variant-picker-tabs__size-wrapper')].map((w) => {
      const input = w.querySelector('.variant-picker-tabs__radio');
      const label = w.querySelector('label');
      const parts = {};
      ((input && input.dataset.fullSize) || '').split('/').forEach((p) => {
        const m = p.trim().match(/^(UK|EU|US)\s*(.+)$/);
        if (m) parts[m[1]] = m[2];
      });
      if (!parts.UK && label) parts.UK = (label.querySelector('.size-region') || label).textContent.trim();
      return {
        input, label, parts,
        mto: !!(label && label.classList.contains('made-to-order')),
        off: !!(input && input.disabled),
        on: !!(input && input.checked && picked),
      };
    }).sort((a, b) => parseFloat(a.parts.UK) - parseFloat(b.parts.UK));
    const lastMap = {};
    (box.dataset.lastLengths || '').split(/\n/).forEach((l) => { const m = l.match(/^\s*([\d.]+)\s*[:=-]\s*([\d.]+)/); if (m) lastMap[String(parseFloat(m[1]))] = m[2]; });
    const lastLengths = Object.keys(lastMap).length > 0;
    box.classList.toggle('has-last', lastLengths);
    box.innerHTML = '';
    const head = document.createElement('div');
    head.className = 'mpdp-sg__row mpdp-sg__row--head';
    (lastLengths ? ['UK', 'EU', 'US', 'Last (mm)', ''] : ['UK', 'EU', 'US', '']).forEach((h) => { const c = document.createElement('span'); c.textContent = h; head.appendChild(c); });
    box.appendChild(head);
    rows.forEach((r) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'mpdp-sg__row' + (r.on ? ' is-on' : '') + (r.off ? ' is-off' : '');
      row.disabled = r.off;
      const cells = [r.parts.UK || '', r.parts.EU || '', r.parts.US || ''];
      if (lastLengths) cells.push(lastMap[String(parseFloat(r.parts.UK))] || '');
      cells.push(r.off ? 'Sold out' : (r.mto ? 'MTO' : 'In stock'));
      cells.forEach((v, k) => {
        const c = document.createElement('span'); c.textContent = v; if (k === cells.length - 1) c.className = 'mpdp-sg__st'; if (lastLengths && k === 3) c.className = 'mpdp-sg__last'; row.appendChild(c);
      });
      row.addEventListener('click', () => { if (r.label) r.label.click(); d.close(); });
      box.appendChild(row);
    });
  };
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('.variant-picker__option--size .variant-picker__option-info .link');
    if (!link) return;
    const d = document.getElementById('mpdp-size-guide');
    if (!d || !d.showModal) return;
    e.preventDefault(); e.stopImmediatePropagation();
    buildSizeTable(d);
    d.showModal();
  }, true);

  // Desktop: "View inside" scrolls the image grid to the cut-open picture (mobile keeps the theme's carousel jump)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.product-gallery__jump-button');
    if (!btn || !document.querySelector('[data-mpdp-sizes]')) return;
    if (!window.matchMedia('(min-width: 1000px)').matches) return;
    const gallery = btn.closest('product-gallery');
    const media = gallery ? [...gallery.querySelectorAll('.product-gallery__media')] : [];
    const n = parseInt(btn.getAttribute('data-gallery-target'), 10);
    const target = media[(isNaN(n) ? media.length : n) - 1] || media[media.length - 1];
    if (!target) return;
    e.preventDefault(); e.stopImmediatePropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.add('mpdp-flash');
    setTimeout(() => target.classList.remove('mpdp-flash'), 1400);
  }, true);

  // Width fitting advice -> our width guide sheet
  document.addEventListener('click', (e) => {
    const link = e.target.closest && e.target.closest('.variant-picker__option--width .variant-picker__option-info .link');
    if (!link) return;
    const d = document.getElementById('mpdp-width-guide');
    if (!d || !d.showModal) return;
    e.preventDefault(); e.stopImmediatePropagation();
    d.showModal();
  }, true);
  document.addEventListener('submit', blockIfNeeded, true);
  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches(SIZE_RADIO)) { picked = true; setButtons(false); }
  }, true);

  const apply = () => {
    document.querySelectorAll('.shopify-section--main-product').forEach((section) => {
      const flag = section.querySelector('[data-mpdp-sizes]');
      if (!flag) return;
      const sizeSet = section.querySelector('.variant-picker__option--size');
      if (!sizeSet) return;
      const tabs = sizeSet.querySelector('variant-picker-tabs');
      if (!tabs) return;

      // 1. Sort sizes numerically by moving them into one list in size order.
      //    (The theme rewrites each size's inline style when you pick a size, so a CSS 'order'
      //    set on them gets wiped for a moment, which made the grid jump. Moving the elements avoids that.)
      const grids = tabs.querySelectorAll('.variant-picker-tabs__grid');
      if (grids.length) {
        const sizeOf = (w) => {
          const r = w.querySelector('.size-region[data-region-index="0"]') || w.querySelector('label');
          const n = parseFloat((r && r.textContent) || '');
          return isNaN(n) ? 999 : n;
        };
        const wrappers = [...tabs.querySelectorAll('.variant-picker-tabs__size-wrapper')];
        const sorted = wrappers.slice().sort((a, b) => sizeOf(a) - sizeOf(b));
        const inOrder = sorted.every((w, k) => w === wrappers[k]) && sorted.every((w) => w.parentElement === grids[0]);
        if (!inOrder) sorted.forEach((w) => grids[0].appendChild(w));
        wrappers.forEach((w) => { if (w.style.order) w.style.removeProperty('order'); });
      }

      // 1b. No size pre-selected until the shopper picks one
      const requireSize = flag.hasAttribute('data-require-size');
      if (requireSize && !picked) {
        tabs.querySelectorAll('.variant-picker-tabs__radio:checked').forEach((r) => { r.checked = false; });
        const val = sizeSet.querySelector('.variant-picker__option-info .h-stack > span:not(.mpdp-size-hint)');
        setButtons(true);
      }

      section.toggleAttribute('data-mpdp-picked', picked || !requireSize);

      // Button + status follow the chosen size: in stock vs made to order
      const chosen = tabs.querySelector('.variant-picker-tabs__radio:checked');
      if (chosen && (picked || !requireSize)) {
        const lab = chosen.nextElementSibling;
        const isMto = !!(lab && lab.classList.contains('made-to-order'));
        const readyTxt = flag.getAttribute('data-ready-label') || 'Ready to ship';
        const mtoTxt = flag.getAttribute('data-mto-label') || 'Made to order';
        const want = 'Add to cart · ' + (isMto ? mtoTxt : readyTxt);
        section.toggleAttribute('data-mpdp-mto', isMto);
        // Keep the status message aligned with the selected size's stock/MTO badge.
        section.querySelectorAll('[data-block-type="variant-info-blocks"] .Yellow__Note').forEach((n) => { n.style.display = isMto ? 'flex' : 'none'; });
        section.querySelectorAll('[data-block-type="variant-info-blocks"] .Black__Note').forEach((n) => { n.style.display = isMto ? 'none' : 'block'; });
        atcButtons().forEach((b) => {
          if (b.disabled || /sold out|unavailable/i.test(b.textContent)) return;
          if (b.textContent.trim() !== want) b.innerHTML = '<span>' + want + '</span>';
        });
      }

      // Keep the stock / made-to-order status box directly under the buy button
      const bbItem = section.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
      const vibItem = section.querySelector('.product-info__block-item[data-block-type="variant-info-blocks"]');
      if (bbItem && vibItem && bbItem.nextElementSibling !== vibItem && bbItem.parentElement === vibItem.parentElement) bbItem.after(vibItem);

      // No long dashes in the stock / made-to-order messages (e.g. "25–30" becomes "25 to 30")
      section.querySelectorAll('[data-block-type="variant-info-blocks"] .Variant__Note, .product-sticky-bar__inventory .Variant__Note').forEach((n) => {
        const w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT);
        let t;
        while ((t = w.nextNode())) {
          if (/[\u2013\u2014]/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/(\d)\s*[\u2013\u2014]\s*(\d)/g, '$1 to $2').replace(/\s*[\u2013\u2014]\s*/g, ', ');
        }
      });

      // Show "x left" for the chosen size inside the grey stock box (only touches the page when it changes)
      {
        let left = '';
        if (chosen && (picked || !requireSize)) {
          const stockEl = chosen.nextElementSibling && chosen.nextElementSibling.querySelector('.variant-stock-component');
          const raw = stockEl ? stockEl.textContent.replace(/\s+/g, ' ').trim() : '';
          const num = parseInt((raw.match(/-?\d+/) || [''])[0], 10);
          const isMtoSize = chosen.nextElementSibling && chosen.nextElementSibling.classList.contains('made-to-order');
          left = (!isMtoSize && num > 0) ? num + ' left' : '';
        }
        section.querySelectorAll('[data-block-type="variant-info-blocks"] .Variant__Note').forEach((n) => {
          const sp = n.querySelector(':scope > .mpdp-stock-left');
          const shown = n.style.display !== 'none' && getComputedStyle(n).display !== 'none';
          const want = shown ? left : '';
          if (!want) { if (sp) sp.remove(); return; }
          let message = n.querySelector(':scope > .mpdp-stock-message');
          if (!message) {
            message = document.createElement('div');
            message.className = 'mpdp-stock-message';
            Array.from(n.childNodes).forEach((child) => {
              if (child !== sp) message.appendChild(child);
            });
            n.insertBefore(message, n.firstChild);
          }
          if (sp) { if (sp.textContent !== want) sp.textContent = want; return; }
          const el = document.createElement('span');
          el.className = 'mpdp-stock-left';
          el.textContent = want;
          n.appendChild(el);
        });
      }

      // Size chart -> Size guide
      sizeSet.querySelectorAll('.variant-picker__option-info .link').forEach((l) => {
        if (/^\s*size chart\s*$/i.test(l.textContent)) l.textContent = 'Size guide';
      });

      // 2. Legend: "SIZE (UK) | True to size"
      const info = sizeSet.querySelector('.variant-picker__option-info');
      const legend = info && info.querySelector('legend');
      if (legend && /:\s*$/.test(legend.textContent)) legend.textContent = legend.textContent.replace(/:\s*$/, '');
      const hint = flag.getAttribute('data-size-hint');
      if (legend && hint && !info.querySelector('.mpdp-size-hint')) {
        const sp = document.createElement('span');
        sp.className = 'mpdp-size-hint';
        sp.textContent = '| ' + hint;
        legend.after(sp);
      }
      const widthLegend = section.querySelector('.variant-picker__option--width legend');
      if (widthLegend && /:\s*$/.test(widthLegend.textContent)) widthLegend.textContent = widthLegend.textContent.replace(/\s*fitting\s*:\s*$/i, '').replace(/:\s*$/, '');

      // 3. Selected size conversion under the grid; lead time stays below Add to Cart.
      let note = sizeSet.querySelector('.mpdp-size-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'mpdp-size-note';
        tabs.after(note);
      }
      const checked = tabs.querySelector('.variant-picker-tabs__radio:checked');
      const wName = (section.querySelector('.width-fitting__values .variant-picker-tabs__radio:checked + label .width-fitting__name') || {}).textContent || '';
      let line = '';
      if (checked && checked.dataset.fullSize && (picked || !requireSize)) {
        const parts = checked.dataset.fullSize.split('/').map((p) => p.trim().replace(/^(UK|EU|US)\s*/, '$1 '));
        if (wName) parts[0] += ' ' + wName.trim();
        line = parts.join(' / ');
      }
      note.hidden = !line;
      if (note.dataset.key !== line) {
        note.innerHTML = line ? '<span class="mpdp-size-note__sel"></span>' : '';
        const sel = note.querySelector('.mpdp-size-note__sel');
        if (sel) sel.textContent = line;
        note.dataset.key = line;
      }
    });
  };

  // Run straight away (MutationObserver callbacks fire before the browser paints),
  // so the theme's re-rendered picker never shows for a frame before we restyle it.
  let running = false;
  const schedule = () => {
    if (running) return;
    running = true;
    try { apply(); } finally { running = false; }
  };
  document.addEventListener('change', schedule, true);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('goral:smugs-product-change', () => {
    picked = false;
    setButtons(true);
    schedule();
  });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();

/* Fallback classes so the layout does not rely on CSS :has() (older Safari / Firefox) */
(function () {
  if (window.__mpdpClassify) return;
  function classify(root) {
    (root || document).querySelectorAll('.shopify-section--main-product').forEach(function (sec) {
      var q = function (x) { return sec.querySelector(x); };
      sec.classList.toggle('mpdp-on', !!q('[data-mpdp-sizes]'));
      sec.classList.toggle('mpdp-req', !!q('[data-mpdp-sizes][data-require-size]'));
      sec.classList.toggle('mpdp-replace', !!q('.mpdp-title--replace'));
      sec.classList.toggle('mpdp-desk', !!q('.mpdp-title--desktop'));
      sec.querySelectorAll('.product-info__block-item').forEach(function (b) {
        b.classList.toggle('mpdp-bi-mobile', !!b.querySelector('.mpdp-mobile-only'));
        b.classList.toggle('mpdp-bi-replace', !!b.querySelector('.mpdp-title--replace'));
        b.classList.toggle('mpdp-bi-jdgm', !!b.querySelector('.jdgm-preview-badge, .jdgm-widget, .jdgm-prev-badge'));
        b.classList.toggle('mpdp-bi-show', !!b.querySelector(':scope > .mpdp, :scope > .mnum'));
      });
      sec.querySelectorAll('.mnum--last').forEach(function (m) {
        m.classList.toggle('mnum--foot', !!m.querySelector('.mnum__footer'));
      });
    });
  }
  window.__mpdpClassify = classify;
  classify();
  document.addEventListener('DOMContentLoaded', function () { classify(); });
  window.addEventListener('load', function () { classify(); });
  document.addEventListener('shopify:section:load', function () { classify(); });
  var lock = function () {
    document.documentElement.classList.toggle('mpdp-lock', !!document.querySelector('dialog.mpdp-modal[open]'));
  };
  new MutationObserver(lock).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
